import PasswordForgotten from "@/views/public/PasswordForgotten.vue";
import RegeneratePassword from "@/views/public/RegeneratePassword.vue";
import RouteEnum from "@/router/RouteEnum";

export default [
    {
        path: "/mot-de-passe-oublie",
        name: RouteEnum.PASSWORD_FORGET,
        component: PasswordForgotten
    },
    {
        path: "/nouveau-mot-de-passe/:token",
        name: RouteEnum.PASSWORD_REGENERATE,
        component: RegeneratePassword
    },
]
